import { render } from "./CompanyPricingSummary.vue?vue&type=template&id=47c5605e&ts=true"
import script from "./CompanyPricingSummary.vue?vue&type=script&lang=ts"
export * from "./CompanyPricingSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__